<template>
  <!-- <pre v-if="responseData"> testData={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/SPAH.png"
        alt="SPAH"
        class="pbt-image"
      >

      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
          />
        </div>
      </div>


      <h2>SISTEM PENGUMPULAN DAN PENGGUNAAN SEMULA AIR HUJAN (SPAH)</h2>
      <div class="spah1">
        <div class="spah1-container">
          <img
            src="@/assets/spah/box.png"
            alt="First Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Bilangan Keseluruhan Bangunan</h3>
              <p class="number">
                {{ Bangunan || 0 }}
              </p>
            </div>
          </div>
        </div>

        <div class="spah1-container">
          <img
            src="@/assets/spah/box.png"
            alt="Second Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Bilangan PBT yang beri maklumbalas</h3>
              <p class="number">
                {{ maklumbalas || 0 }}
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="spah">
        <div
          v-for="(item, index) in spahData"
          :key="index"
          class="spah-container"
        >
          <img
            src="@/assets/spah/box.png"
            alt="Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>{{ item.title }}</h3>
              <p class="number">
                {{ item.value }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-wrapper">  
        <Bar 
          :chart-data="KelasChartData"
          :chart-categories="KelasChartNames"
          :chart-colors="['#00c057', '#ffbf87', '#ff922e', '#f00000', '#6b7080']"
        />
      </div>
    </div>
    <PrimaryModule />
    <KejuruteraanAwamMenu />
  </adminbackground>
</template>


<script setup>
import Bar from "@/components/chart/Bar.vue"
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'


const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const KelasChartData = ref([])
const KelasChartNames = ref([])

const Bangunan = ref(0)
const maklumbalas = ref(0)

const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)

async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {


    const plainStates = toRaw(state)

    let queryParams = `year=${year}`
    console.log('Plain states:', plainStates)


    if (!plainStates.includes("Semua Negeri")) {

      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }


    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    const url = `kejuruteraan-awam/spah?${queryParams}`

    const response = await httpGet(url)

    years.value = response.years

    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = response.councils
    responseData.value = response

    responseData.value = response

    const kelas = response.data?.spah

    Bangunan.value = kelas?.bilangan_keseluruhan_bangunan || 0
    maklumbalas.value = kelas?.bilangan_pbt_beri_maklumbalas || 0

    const filteredData = Object.entries(kelas)
      .filter(([key]) => key !== "bilangan_keseluruhan_bangunan" && key !== "bilangan_pbt_beri_maklumbalas")

    KelasChartData.value = filteredData.map(([_, value]) => value)
    KelasChartNames.value = filteredData.map(([key]) => 
      key.replace(/bilangan_/g, '')
        .replace(/_/g, ' ') 
        .replace(/\b\w/g, char => char.toUpperCase()), 
    )
  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []


  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }


  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }


  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }


  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }


  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
  
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
 
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}

onMounted(() => {
  loadDataFromApi()
  
})

watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); 
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; 
  height: auto;
}

.line-under-image {
  width: 70%; 
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
}



.spah1 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 10px; 
}

.spah1-container {
  width: 48%; 
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}

.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.input-item {
  flex: 1;
  margin-right: 15px;
}

.input-item:last-child {
  margin-right: 0;
}

.spah {
  display: grid;
  grid-template-columns: repeat(4, 1fr); 
  grid-gap: 10px; 
  margin-bottom: 20px;
}

.spah-container {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; 
}

.values-layered h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 20px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

.chart-wrapper {
  width: 100%;
  max-width: 1200px; 
  margin-bottom: 50px; 
  padding: 20px;
  background: rgba(255, 254, 254, 0.8);
  border-radius: 10px; 
  height: auto;
}


.status-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white; 
}

.status-table th, .status-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

.status-table th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #333;
  text-transform: uppercase;
}

.status-table td {
  color: #000;
}


@media (max-width: 768px) {
  .input-row {
    flex-direction: column;
    gap: 10px;
  }

  .spah {
    grid-template-columns: repeat(2, 1fr);
  }

  h2 {
    font-size: 1.3rem;
  }

  .values-layered h3 {
    font-size: 12px;
  }

  .number {
    font-size: 18px;
  }

  .chart-wrapper {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .pbt-image {
    max-width: 90%;
  }

  .line-under-image {
    width: 90%;
  }

  h2 {
    font-size: 1.1rem;
  }

  .spah {
    grid-template-columns: 1fr;
  }

  .values-layered h3 {
    font-size: 11px;
  }

  .number {
    font-size: 16px;
  }

  .input-item {
    width: 100%;
    margin-right: 0;
  }

  .spah-container {
    width: 100%;
  }

  .chart-wrapper {
    padding: 10px;
    margin-bottom: 30px;
  }
}
</style>

